import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from '@elbklar/ui';
import { tasksApi } from '@/lib/api';
import { formatApiError } from '@/lib/validation';

/**
 * Status einer Aufgabe ändern, für `TaskCard onStatusChange`: Aufgaben-Liste,
 * „Heute fällig“, Übersicht und Kunden-Detail erledigen auf demselben Weg.
 * Das Promise endet erst, wenn die Listen neu geladen sind; so bleibt der
 * Haken bis dahin stehen.
 */
export function useAufgabeErledigen() {
  const queryClient = useQueryClient();
  return useCallback(
    async (taskId: string, status: string) => {
      try {
        await tasksApi.update(taskId, { status });
        if (status === 'completed') toast.success('Aufgabe erledigt');
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ['tasks'] }),
          queryClient.invalidateQueries({ queryKey: ['dashboard'] }),
          queryClient.invalidateQueries({ queryKey: ['activity-feed'] }),
        ]);
      } catch (err) {
        toast.error(formatApiError(err) || 'Aufgabe ließ sich nicht erledigen');
      }
    },
    [queryClient],
  );
}
